import { ChangeEvent, useCallback, useState, useEffect } from "react";
import { useSAL1010_R01Store, defaultSAL1010_R01Filter } from "./Store_SAL1010_R01";
import { SearchCodeModalForm } from "src/components/common/form/search/SearchCodeModalForm";
import { SearchDateRangeForm } from "src/components/common/form/search/SearchDateRangeForm";
import { SearchSectionForm } from "src/components/common/form/search/SearchSectionForm";
import useUiuxStore from "src/store/useUiuxStore";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import { useInfoFormEvents } from "src/hooks/useInfoFormEvents";
import { InfoCodeSearchFieldConfig } from "src/types/info-form";
import {  searchCustomer } from "src/apis/customerApi";
import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";

export const SearchSection_SAL1010_R01 = () => {
	const { SAL1010_R01Filter, setSAL1010_R01Filter } = useSAL1010_R01Store();
	const { codeSearchModalVisible, setCodeSearchModalProps } = useUiuxStore();
	const { yesNoList } = useCommonCodeStore();
	
	const [pickerVisible, setPickerVisible] = useState(false);
	const [pickerPosition, setPickerPosition] = useState<{ top: number; left: number }>({ top: 0, left: 0 });

	const custInfoHandleFoucsId = 'infoCustInput_search';
	
	// Info 폼 코드 검색 필드 설정
	const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
		{
			fieldName: 'customCd',
			category: '거래처',
			focusId: custInfoHandleFoucsId,
			responseMapping: {
				customCd: 'customCd',
				customNm: 'customNm',
			},
			searchFunction: async (searchText: string) => {
				const customerResponse = await searchCustomer(searchText);
				return customerResponse.data.data.find(value => value.customCd === searchText);
			},
			extraFilter: () => ({
				customCd: SAL1010_R01Filter.customCd || '',
				customNm: SAL1010_R01Filter.customNm || '',
			}),
		},		
	];

	// Info 폼 이벤트 훅 사용
	const { getFieldHandlers } = useInfoFormEvents({
		editData: SAL1010_R01Filter,
		setEditData: setSAL1010_R01Filter,
		defaultData: defaultSAL1010_R01Filter,
		infoFieldConfigs,
		setCodeSearchModalProps,
		formName: 'SAL1010_R01_search'
	});

	return (
		<>
			<SearchSectionForm>
				<SearchDateRangeForm
					label="수주일자"
					visible={pickerVisible}
					setVisible={setPickerVisible}
					dateRange={SAL1010_R01Filter.dateRange}
					setDateRange={(dateRange) => setSAL1010_R01Filter({ dateRange: dateRange })}
					pickerPosition={pickerPosition}
					setPickerPosition={setPickerPosition}
				/>
				{/* 거래처 입력 및 검색 영역 */}
				<SearchCodeModalForm
					label="거래처"
					value={SAL1010_R01Filter.customCd}
					valueLabel={SAL1010_R01Filter.customNm}
					handleFoucsId={custInfoHandleFoucsId}
					onChange={getFieldHandlers('customCd').onChange}
					onDoubleClick={getFieldHandlers('customCd').onDoubleClick}
					onKeyDown={getFieldHandlers('customCd').onEnterKeyDown}
				/>
				<SearchDropDownForm
					label="수주마감포함"
                    wrapperOption={{
                        titleStyle: 'h-[24px] flex items-center truncate shrink-0 w-[70px] min-w-[70px]',
                        selectStyle : 'w-[120px] min-w-[120px] ',
                    }}
					value={SAL1010_R01Filter.orderStatus}
					onChangeItem={(item) => setSAL1010_R01Filter({ orderStatus: item?.minorCd || ''})}
					optionList={yesNoList}
				/>
			</SearchSectionForm>
		</>
	);
};

export default SearchSection_SAL1010_R01; 